import { useState } from "react";
import { Loader2, MessageCircle } from "lucide-react";
import { toast } from "sonner";
import { api, API, errMsg } from "@/lib/api";
import { Button } from "@/components/ui/button";

export function WhatsAppButton({ kind, id, label, onSent, className = "", testId }: { kind: string; id: string; label: string; onSent?: () => void; className?: string; testId?: string }) {
  const [busy, setBusy] = useState(false);
  const send = async () => {
    const win = window.open("", "_blank");
    setBusy(true);
    try {
      const r = await api.post("/share/whatsapp", { kind, doc_id: id });
      const text = r.data.message.replace("{lien}", `${API}/public/doc/${r.data.token}`).replace("{accord}", `${window.location.origin}/accord/${r.data.token}`);
      const url = `https://wa.me/${r.data.phone}?text=${encodeURIComponent(text)}`;
      if (win) win.location.href = url;
      else window.location.href = url;
      toast.success(`WhatsApp ouvert pour le +${r.data.phone} : appuyez sur Envoyer`);
      onSent?.();
    } catch (e) {
      win?.close();
      toast.error(errMsg(e));
    }
    setBusy(false);
  };
  return (
    <Button onClick={send} disabled={busy} className={`bg-[#25D366] text-black hover:bg-[#1ebe5a] ${className}`} data-testid={testId || `whatsapp-${kind}-btn`}>
      {busy ? <Loader2 className="mr-2 h-4 w-4 animate-spin" /> : <MessageCircle className="mr-2 h-4 w-4" />}
      {label}
    </Button>
  );
}

export function WhatsAppHistory({ entries, testId }: { entries?: any[]; testId: string }) {
  if (!entries?.length) return null;
  return (
    <div className="mt-3 space-y-1 text-xs text-muted-foreground" data-testid={testId}>
      {entries.map((e, i) => <div key={i}>WhatsApp {e.kind === "reminder" ? "(relance) " : ""}préparé pour +{e.to} le {new Date(e.at).toLocaleString("fr-FR", { dateStyle: "short", timeStyle: "short" })} par {e.by}</div>)}
    </div>
  );
}
